import { View, StyleSheet } from 'react-native';
import { Text, Modal, theme, type WrappedButtonProps, modalStyles } from '@socrait/react';

type ArchiveModalProps = {
  isOpen: boolean;
  isArchivePending?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function ArchiveModal({ isOpen, isArchivePending, onClose, onConfirm }: ArchiveModalProps) {
  const content = (
    <View style={styles.content}>
      <Text style={modalStyles.text}>
        Archiving this class will hide it from the dashboard, but you can still view your data in Archived Classes.
      </Text>
      <Text style={modalStyles.text}>Don't worry, you can also restore the class if you need to.</Text>
    </View>
  );

  const buttons: WrappedButtonProps[] = [
    {
      name: 'Cancel',
      onPress: onClose,
    },
    {
      name: 'Archive',
      icon: 'archive',
      onPress: onConfirm,
      loading: isArchivePending,
      variant: 'primary',
    },
  ];

  return (
    <Modal
      title={'Archive this class?'}
      content={content}
      buttons={buttons}
      modalVisible={isOpen}
      handleClose={onClose}
      buttonLayout={'row'}
    />
  );
}

const styles = StyleSheet.create({
  content: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing.xxlarge,
    textAlign: 'center',
  },
});
